import { Controller } from '@hotwired/stimulus'
import { mountChatDock, unmountChatDock } from '../lib/chat_dock_mount'
import { mountCallWidget, unmountCallWidget } from '../components/call_center/widget/CallWidget'

const COMPACT_VIEWPORT_BREAKPOINT = 1200

function skipFloatingWidgets() {
  return Boolean(window.ondeviceai) || window.innerWidth < COMPACT_VIEWPORT_BREAKPOINT
}

/** Mount nodes — never tear down on Stimulus disconnect (Turbo permanent relocate). */
let lastChatDockEl = null
let lastCallEl = null

function dropWidgetsIfGone() {
  if (!document.getElementById('chat-dock-root') && lastChatDockEl) {
    unmountChatDock(lastChatDockEl)
    lastChatDockEl = null
  }
  if (!document.getElementById('call-center-float-container') && lastCallEl) {
    unmountCallWidget(lastCallEl)
    lastCallEl = null
  }
}

document.addEventListener('turbo:load', dropWidgetsIfGone)
window.addEventListener('pagehide', dropWidgetsIfGone)

export default class extends Controller {
  static targets = ['chatDock', 'chatFloat', 'call']

  static values = {
    hideChatDock: { type: Boolean, default: false },
    personId: { type: Number, default: 0 },
    personName: { type: String, default: '' },
    tenantId: { type: String, default: '' },
    canManageRooms: { type: Boolean, default: false },
    avatarUrl: { type: String, default: '' },
    unreadCount: { type: Number, default: 0 },
    callApiBase: { type: String, default: '/api/call_center' },
  }

  connect() {
    if (skipFloatingWidgets()) return
    const el = this.element

    if (el.__wmLifecycle === 'live') {
      el.classList.add('wm-turbo-settled')
      this.ensureChildMounts()
      return
    }

    el.__wmLifecycle = 'live'
    this.ensureChildMounts()
  }

  ensureChildMounts() {
    if (this.hasChatDockTarget && !this.hideChatDockValue && !this.chatDockTarget.__chatDockMount) {
      lastChatDockEl = this.chatDockTarget
      this.chatMount = mountChatDock(this.chatDockTarget, {
        personId: this.personIdValue,
        personName: this.personNameValue,
        tenantId: String(this.tenantIdValue),
        canManageRooms: this.canManageRoomsValue,
        avatarUrl: this.avatarUrlValue,
        unreadCount: this.unreadCountValue,
      })
    }

    if (this.hasCallTarget && !this.callTarget.__callWidgetMounted) {
      lastCallEl = this.callTarget
      mountCallWidget(this.callTarget, this.callApiBaseValue)
    }
  }

  // Intentionally empty — chat + call unmount only in dropWidgetsIfGone when slot ids leave the DOM.
  disconnect() {}
}
